// extracted by mini-css-extract-plugin
export default {"overlay":"EB-z","bodyOpen":"FB-z","content":"GB-z","header":"HB-z","close":"IB-z","closeNoHeading":"JB-z"};